<template>
  <div class="logo">
    <img
      v-if="domain.includes('dvgroup.com')"
      src="@/assets/images/logo_white.svg"
      alt="logo"
    />
    <div class="text" v-else-if="domain.includes('cvdashboard.ru')">
      CooperVision
    </div>
    <div class="text" v-else>CDP</div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentDomain } from "@/services/utils/Domain";

const domain = getCurrentDomain();
</script>

<style scoped lang="scss">
.logo {
  position: relative;
  height: 100%;
  background: rgb(103, 49, 230);
  border-radius: 20px;

  img,
  div.text {
    position: absolute;
    width: 295px;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }

  div.text {
    color: white;
    width: fit-content;
    font-size: 5rem;
    font-weight: 300;
  }
}
</style>
